import { useEffect } from 'react';
import { useSignalRQuery } from '../hooks/useSignalr';
import { HubsNames } from '../stores/useSignalR';
import { ProfileSignalRQueryOperation } from '../types/api/profile';
import { useFilterOptions } from '../stores/useFilterOptions';


export const FilterOptionsInitializer = () => {
  const { setData } = useFilterOptions();

  const { data } = useSignalRQuery({
    hubName: HubsNames.filterOptions,
    method: ProfileSignalRQueryOperation.GetFilterOptions,
    queryKey: [ProfileSignalRQueryOperation.GetFilterOptions],
    options: {
      staleTime: 10000, // Кэширование результатов на 10 секунд
      refetchOnWindowFocus: false,
      onError: (error: any) => {
        console.error('Error fetching filter options', error);
      },
    },
  });

  useEffect(() => {
    if (data) {
      setData(data);
    }
  }, [data, setData]);

  return null;
}; 